import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _createSuper from "@babel/runtime/helpers/esm/createSuper";
import React, { Component } from 'react';
import { SVGIcon } from '@instructure/ui-svg-images';

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M320.0064,960.031999 C320.0064,1312.89788 607.057882,1600.0064 960.032001,1600.0064 C1133.79895,1600.0064 1294.12537,1530.24919 1411.97008,1411.93392 L1411.97008,1411.93392 L1200.0416,1200.0224 L1680.0608,1200.0224 L1680.0608,1680.0032 L1525.0146,1524.8894 C1377.64871,1672.88348 1177.24069,1760 960.032001,1760 C518.814353,1760 160,1401.13435 160,960.031999 L160,960.031999 Z M959.967999,160 C1401.18565,160 1760,518.865645 1760,959.968001 L1760,959.968001 L1599.9936,959.968001 C1599.9936,607.102116 1312.94212,319.9936 959.967999,319.9936 C786.201048,319.9936 625.874635,389.75081 508.029921,508.066077 L508.029921,508.066077 L719.958398,719.977601 L239.939198,719.977601 L239.939198,239.9968 L394.985399,395.030599 C542.351294,247.116515 742.75931,160 959.967999,160 Z",
  fillRule: "evenodd",
  stroke: "none",
  strokeWidth: "1"
});

var IconProgressLine = /*#__PURE__*/function (_Component) {
  _inherits(IconProgressLine, _Component);

  var _super = _createSuper(IconProgressLine);

  function IconProgressLine() {
    _classCallCheck(this, IconProgressLine);

    return _super.apply(this, arguments);
  }

  _createClass(IconProgressLine, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement(SVGIcon, Object.assign({}, this.props, {
        name: "IconProgress",
        viewBox: "0 0 1920 1920"
      }), _ref);
    }
  }]);

  IconProgressLine.displayName = "IconProgressLine";
  return IconProgressLine;
}(Component);

IconProgressLine.glyphName = 'progress';
IconProgressLine.variant = 'Line';
IconProgressLine.propTypes = _objectSpread({}, SVGIcon.propTypes);
export default IconProgressLine;
export { IconProgressLine };